module.exports = __webpack_public_path__ + "static/media/icons8-bar-chart.fa5443db.svg";